import { render, staticRenderFns } from "./WHOISMonitoringHistory.vue?vue&type=template&id=a2b94e4a&scoped=true&"
import script from "./WHOISMonitoringHistory.vue?vue&type=script&lang=js&"
export * from "./WHOISMonitoringHistory.vue?vue&type=script&lang=js&"
import style0 from "./WHOISMonitoringHistory.vue?vue&type=style&index=0&id=a2b94e4a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2b94e4a",
  null
  
)

export default component.exports